// Dev-only logger. In production builds (`NODE_ENV === "production"`), these are no-ops
// so we don't leak diagnostic info into the browser console for real users.
// Swap for Sentry / LogRocket etc. when we wire up an APM.

const isDev = process.env.NODE_ENV !== "production";

export const logDev = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default logDev;
